import {scriptonload} from '../modules/scriptonload';

class ScrollSlider {
    constructor(el) {
        var self = this;

        this.status; /* если вдруг решим удалить объект, а он еще не загрузился */
        this.oScrollbar;

        this.status = 'loading';
        scriptonload(APP.vendors.scrolling, function(){self._init.call(self, el)});
    }

    _init(el){
        if(this.status === 'notload') return;
        this.status = 'loaded';

        var self = this;

        this.offset = 220; /* TODO */

        this.btnLeft = el.querySelector('[data-scrollslider-btn="left"]');
        this.btnRight = el.querySelector('[data-scrollslider-btn="right"]');
        this.overview = el.querySelector('[data-scrolling-overview]');
        this.itemAll = el.querySelector('[data-scrollslider-item]');
        this.oScrollbar = tinyscrollbar(el,{
            axis: "x",
            trackSize: el.getBoundingClientRect().width,
            onStartPoint: function(){
                var cls = self.btnLeft.className;
                if(cls.indexOf('js-disabled') === -1) self.btnLeft.className = cls + ' js-disabled';
            },
            onEndPoint: function(){
                var cls = self.btnRight.className;
                if(cls.indexOf('js-disabled') === -1) self.btnRight.className = cls + ' js-disabled';
            },
            onWayPoint: function(){
                if(self.btnLeft.className.indexOf('js-disabled') !== -1) self.btnLeft.className = self.btnLeft.className.replace(' js-disabled', '');
                if(self.btnRight.className.indexOf('js-disabled') !== -1) self.btnRight.className = self.btnRight.className.replace(' js-disabled', '');
            }
        });

        this._addEvents();
    }

    _addEvents(){
        var self = this,
            handler = function(e){
                e.preventDefault();

                if(this.className.indexOf('js-disabled') !== -1) return;

                var name = this.getAttribute('data-scrollslider-btn');
                self._move.call(self, name);
            };

        this.btnLeft.addEventListener('click', handler, false);
        this.btnRight.addEventListener('click', handler, false);
    }

    _move(name){
        var left = Math.abs(parseInt(this.overview.style.left)) || 0,
            offset = name === 'left' ? -this.offset : this.offset;

        left = (Math.round((left + offset)/this.offset))*this.offset;

        this.oScrollbar.update(left);
    }

    del(){
        /*if(this.oScrollbar) this.oScrollbar.del();
        else this.status = 'notload';*/
        if(!this.oScrollbar) this.status = 'notload';
        else {
            this.btnLeft.removeEventListener('click', handler, false);
            this.btnRight.removeEventListener('click', handler, false);
        }
    }
}

export {ScrollSlider};




































